<h1 mat-dialog-title>Payment Authorization</h1>
<div mat-dialog-content style="min-height: 275px;">

  <div *ngIf="!isDoItYourself else doItYourself">
    <form [formGroup]="formPayeeInfo" autocomplete="off">
      <p>Who do you authorize for payment?</p>
      <mat-radio-group style="display: columns;"
        id="payeeTypeCode" name="payeeTypeCode"
        formControlName="payeeTypeCode"
        (change)="onChangeEventPayee($event)"
        aria-label="Select an option" lass="retrofit-task-radio-group">
        <div>   <mat-radio-button value="700000000"> {{ homeOwnerLabel }}</mat-radio-button>
        </div>
        <div>        <mat-radio-button value="700000001"> Contractor </mat-radio-button>
        </div> </mat-radio-group>
    </form>
  </div>
  <ng-template #doItYourself>
    <h6>Do it myself retrofit</h6>
    <p>You can authorize payment only for yourself</p>
  </ng-template>

  <div style="margin-top: 15px;" *ngIf="currentPayee; else payeeInstructions">
    <div *ngIf="data.programType === 700000004 && currentPayee === 700000000">
      <form [formGroup]="formPropertyInfo" autocomplete="off">
        
        <!-- Property Owner Name -->
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Property Owner Name</mat-label>
          <input
            matInput
            placeholder="Property Owner Name"
            id="pafFullName"
            name="pafFullName"
            formControlName="pafFullName"
            maxLength="100"
            required
          />
          <mat-error *ngIf="onCheckPayeeControlValidators('pafFullName')">
            Property Owner Name is required
          </mat-error>
          <mat-hint *ngIf="formPropertyInfo.get('pafFullName').value?.length >= 100">
            100 character limit
          </mat-hint>
        </mat-form-field>
        
        <!-- Mailing Address -->
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Mailing Address</mat-label>
          <input
            matInput
            placeholder="Mailing Street Address"
            id="pafAddressStreet"
            name="pafAddressStreet"
            formControlName="pafAddressStreet"
            maxLength="100"
            required
          />
          <mat-error *ngIf="onCheckPayeeControlValidators('pafAddressStreet')">
            Mailing address is required
          </mat-error>
          <mat-hint *ngIf="formPropertyInfo.get('pafAddressStreet').value?.length >= 100">
            100 character limit
          </mat-hint>
        </mat-form-field>
        
        <!-- City -->
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>City</mat-label>
          <input
            matInput
            placeholder="City"
            id="pafAddressCity"
            name="pafAddressCity"
            formControlName="pafAddressCity"
            maxLength="100"
            required
          />
          <mat-error *ngIf="onCheckPayeeControlValidators('pafAddressCity')">
            City is required
          </mat-error>
          <mat-hint *ngIf="formPropertyInfo.get('pafAddressCity').value?.length >= 100">
            100 character limit
          </mat-hint>
        </mat-form-field>
        
        <!-- State -->
<mat-form-field appearance="outline" style="width: 100%;">
  <mat-label>State</mat-label>
  <input
    matInput
    id="pafAddressState"
    name="pafAddressState"
    formControlName="pafAddressState"
    required
    
  />
  
</mat-form-field>

        <!-- ZIP Code -->
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>ZIP Code</mat-label>
          <input
          mask="99999"
            matInput
            placeholder="ZIP Code"
            id="pafAddressZip"
            name="pafAddressZip"
            formControlName="pafAddressZip"
            maxLength="10"
            required
          />
          <mat-error *ngIf="onCheckPayeeControlValidators('pafAddressZip')">
            ZIP Code is required
          </mat-error>
          <mat-hint *ngIf="formPropertyInfo.get('pafAddressZip').value?.length >= 10">
            Maximum 10 characters
          </mat-hint>
        </mat-form-field>
        
      </form>
    </div>
  
    <!-- Alternate Payee Information -->
    <div *ngIf="data.programType !== 700000004 || (data.programType === 700000004 && currentPayee === 700000001)">
      <p *ngIf="data.pafCompany?.length > 0" style="margin-bottom: 3px;">
        {{ data.pafCompany }}
      </p>
      <p>{{ data.pafFullName }}</p>
      <address>
        {{ data.pafAddressStreet }}<br />
        {{ data.pafAddressCity }}, {{ data.pafAddressState }}<br />
        {{ data.pafAddressZip }}
      </address>
    </div>
    
    <!-- Authorization Date -->
    <small>Authorized on {{ currentDate.toLocaleDateString('en-US') }}</small>
  </div>
  
  <ng-template #payeeInstructions>
    <div style="margin-top: 21px;">
      <p>
        Payment authorization is used to authorize to whom the progam incentive payment is to be paid.
      </p>
    
    </div>
  </ng-template>

</div>
<div mat-dialog-actions style="margin-top: 18px !important; float: right !important;">
  <button mat-button id="dialogPaFormCancelButton"
    style="margin-right: 6px;"
    (click)="onClickCancel()">
    CANCEL
  </button>
  
  <button mat-flat-button id="dialogPaFormSaveButton" *ngIf="(data.programType !== 700000004) || (data.programType === 700000004 && currentPayee ===700000001)"
  (click)="onClickSave()"
  color="primary"
  [disabled]="(formPayeeInfo.pristine || formPayeeInfo.invalid) && !this.isDoItYourself">
  SAVE
</button>
  <button mat-flat-button id="dialogPaFormSaveButton" *ngIf="data.programType === 700000004 &&  currentPayee ===700000000"
    (click)="onClickSavePayeeInfo()"
    color="primary"
    [disabled]="(formPayeeInfo.pristine || formPayeeInfo.invalid||formPropertyInfo.pristine || formPropertyInfo.invalid) && !this.isDoItYourself">
    SAVE
  </button>
</div>